export const generateTrackingCode = () => {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const length = 8;

    var result = '';

    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * length)];

    result = result.slice(0, 4) + '-' + result.slice(4);

    return result;
};
